import React, { useEffect, useContext, useState } from "react";
import CryptoContext from "../context/crypto/cryptoContext";
import NewsContainer from "../components/News/NewsContainer";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

import NumberFormat from "react-number-format";
import moment from "moment";
import Chart from "./SingleCryptoChart";
import { formatPrice } from "../helpers/format";
import { AiOutlineCaretDown, AiFillCaretUp } from "react-icons/ai";
import BreadCrumbs from "../components/BreadCrumbs";
import NewsContext from "../context/News/NewsContext";
import { BiLinkExternal } from "react-icons/bi";
import authContext from "../context/auth/authContext";
import parameterContext from "../context/parameter/parameterContext";

import { FcInfo } from "react-icons/fc";
const SingleCrypto = ({ match, history, location }) => {
  const {
    getSingleCryptoDetails,
    singleCryptoData,

    loading,
    getCompareCryptoCoinData1,
    convt,
    livePriceData,
    currencySymbol,
    exchangeRate,
    getSparklines,

    singleSparklineData,
  } = useContext(CryptoContext);
  const {  addFavouriteCoin } = useContext(authContext);
  const localCurrency = useState(convt)[0];
  const [favouriteTab, setFavouriteTab] = useState("basic");
  const { getNews, getSpecificNews, sentimentData } = useContext(NewsContext);
  const { setTimeInChart, timeInChart } = useContext(parameterContext);
  const sentimentAnalysis = sentimentData && sentimentData[0];
  let total;
  if (sentimentData && typeof sentimentData != "undefined") {
    total =
      sentimentAnalysis.negative +
      sentimentAnalysis.positive +
      sentimentAnalysis.neutral;
  }

  useEffect(() => {
    getSingleCryptoDetails(match.params.id);
    getSpecificNews(match.params.id);
    getNews(1, "single");

    getSparklines(match.params.id, timeInChart, localCurrency);
    //eslint-disable-next-line
  }, [match.params.id]);

  useEffect(() => {
    setTimeInChart("1d");

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    getSparklines(match.params.id, timeInChart, localCurrency);

    //eslint-disable-next-line
  }, [timeInChart]);
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   // clearSingleCryptoDetails();

  //   if (localCurrency !== convt) {
  //     getSingleCryptoDetails(match.params.id, localCurrency);
  //   } else {
  //     getSingleCryptoDetails(match.params.id);
  //   }
  //   // console.log("rndered");
  //   // getNamesOfDisplayedCryptoData(2);
  // }, [match, convt, localCurrency]);

  // console.log("modeled");
  const handleClick = () => {
    getCompareCryptoCoinData1(match.params.id);
    history.push("/compare");
  };
  const routes = [
    { path: "/", name: "Cryptos" },
    { path: "/:id", name: `${match.params.id}` },
  ];
  const handleFavouriteClick = (id) => {
    addFavouriteCoin(id);
  };
  const crypto =
    singleCryptoData && singleCryptoData.length > 0
      ? singleCryptoData[0]
      : null;

  return crypto || loading ? (
    <div className="SingleCrypto">
      <div className="SingleCrypto__container">
        <BreadCrumbs routes={routes} />
        <div className="SingleCrypto__grid">
          <div>
            <div className="SingleCrypto__grid__heading">
              {loading || !crypto || !livePriceData ? (
                <div
                  className="skeleton avatar"
                  style={{
                    width: "50px",
                    height: "50px",
                    marginRight: "5px",
                  }}
                />
              ) : (
                crypto.logo_url &&
                crypto.name && (
                  <img
                    src={crypto.logo_url}
                    alt={crypto.name}
                    style={{ width: "50px", height: "50px" }}
                  />
                )
              )}
              {loading || !crypto || !livePriceData ? (
                <div
                  className="skeleton text"
                  style={{ width: "150px", height: "30px" }}
                />
              ) : (
                crypto.name && <h1>{crypto.name}</h1>
              )}
              {loading || !crypto || !livePriceData ? (
                <div
                  className="skeleton text"
                  style={{ width: "50px", height: "30px" }}
                />
              ) : (
                crypto.id && <h1>{crypto.id}</h1>
              )}
            </div>
            <div>
              {loading || !crypto || !livePriceData ? (
                <div
                  className="skeleton text"
                  style={{ width: "0px", height: "0px" }}
                />
              ) : (
                crypto.rank && (
                  <h3
                    style={{
                      display: "inline-block",
                      margin: "20px 10px 0 0",
                    }}
                  >
                    Rank: {crypto.rank}
                  </h3>
                )
              )}
              <p style={{ display: "inline-block" }}>No.of times pinned</p>
            </div>
            <div className="SingleCrypto__buttons__group">
              <button
                className="SingleCrypto__grid__compare__button"
                onClick={handleClick}
              >
                Compare
              </button>
              <ScrollLink
                to="news"
                spy={true}
                smooth={true}
                offset={-50}
                duration={500}
              >
                <button className="SingleCrypto__grid__moreinfo__button">
                  News
                </button>
              </ScrollLink>
            </div>
          </div>
          <div>
            <div className="SingleCrypto__secondgrid">
              <div className="SingleCrypto__priceheader">
                {loading || !crypto || !livePriceData ? (
                  <div
                    className="skeleton text"
                    style={{ width: "250px", height: "30px" }}
                  />
                ) : (
                  crypto.price && (
                    <h1>
                      <span>
                        {
                          <NumberFormat
                            value={
                              livePriceData
                                ? formatPrice(livePriceData[crypto.id])
                                : formatPrice(crypto.price / exchangeRate)
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={currencySymbol}
                          />
                        }
                      </span>
                      {crypto["1d"] && crypto["1d"].price_change_pct && (
                        <span
                          style={{
                            color:
                              Number(crypto["1d"].price_change_pct) > 0
                                ? "rgba(69, 170, 67, 1)"
                                : "rgba(233, 56, 72, 1)",
                          }}
                        >
                          {Number(crypto["1d"].price_change_pct) > 0 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          )}
                          &nbsp;
                          <span>
                            {Math.abs(
                              Number(crypto["1d"].price_change_pct) * 100
                            ).toFixed(2) + "%"}
                          </span>
                        </span>
                      )}
                    </h1>
                  )
                )}
              </div>
              <table>
                <tr>
                  <td>Market Cap:</td>
                  {loading || !crypto || !livePriceData ? (
                    <td>
                      <div
                        className="skeleton text"
                        style={{ width: "250px", height: "20px" }}
                      />
                    </td>
                  ) : (
                    <td>
                      {crypto.market_cap ? (
                        <NumberFormat
                          displayType={"text"}
                          thousandSeparator={true}
                          value={crypto.market_cap / exchangeRate}
                          prefix={`${currencySymbol} `}
                        />
                      ) : (
                        <></>
                      )}
                    </td>
                  )}
                </tr>
                <tr>
                  <td>Volume 24/hr:</td>
                  {loading || !crypto || !livePriceData ? (
                    <td>
                      <div
                        className="skeleton text"
                        style={{ width: "250px", height: "20px" }}
                      />
                    </td>
                  ) : (
                    <td>
                      {crypto["1d"] && crypto["1d"].volume ? (
                        <NumberFormat
                          displayType={"text"}
                          thousandSeparator={true}
                          value={formatPrice(
                            crypto["1d"].volume / exchangeRate
                          )}
                          prefix={`${currencySymbol} `}
                        />
                      ) : (
                        <>NA</>
                      )}
                    </td>
                  )}
                </tr>
                <tr>
                  <td>Dominance:</td>
                  {loading || !crypto || !livePriceData ? (
                    <td>
                      <div
                        className="skeleton text"
                        style={{ width: "250px", height: "20px" }}
                      />
                    </td>
                  ) : (
                    <td>
                      {crypto.market_cap_dominance ? (
                        (crypto.market_cap_dominance * 100).toFixed(2) + "%"
                      ) : (
                        <>NA</>
                      )}
                    </td>
                  )}
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div>
          <div className="Favourite__tabs">
            <button
              className={
                favouriteTab === "basic"
                  ? "Favourite__exchange-tab"
                  : "Favourite__portfolio-tab"
              }
              onClick={() => setFavouriteTab("basic")}
            >
              Basic
            </button>
            <button
              className={
                favouriteTab === "advanced"
                  ? "Favourite__exchange-tab"
                  : "Favourite__portfolio-tab"
              }
              onClick={() => setFavouriteTab("advanced")}
            >
              Advanced
            </button>
          </div>
        </div>

        <div>
          {favouriteTab === "basic" &&
            singleSparklineData &&
            singleSparklineData.length > 0 && (
              <Chart
                symbol={match.params.id}
                currencySymbol={currencySymbol}
                localCurrency={localCurrency}
              />
            )}
          {favouriteTab === "advanced" && (
            <div>
              <div style={{ textAlign: "right" }}>
                <a
                  href={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_bfec4&symbol=${
                    match.params.id
                  }${
                    match.params.id === "USDT" ? "TRY" : "USDT"
                  }&interval=D&hidesidetoolbar=0&symboledit=1&show_popup_button=true&popup_width=1000&popup_height=500&saveimage=1&toolbarbg=F1F3F6&studies=[]&hideideas=1&theme=Light&style=1&timezone=Etc/UTC&studies_overrides={}&overrides={}&enabled_features=[]&disabled_features=[]&locale=en&utm_source=coinmarketcap.com&utm_medium=widget&utm_campaign=chart&utm_term=BTCUSDT`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <BiLinkExternal size={26} />
                </a>
              </div>
              <iframe
                style={{ width: "100%", height: "500px", border: 0 }}
                title="trading__view"
                src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_bfec4&symbol=${
                  match.params.id
                }${
                  match.params.id === "USDT" ? "TRY" : "USDT"
                }&interval=D&hidesidetoolbar=0&symboledit=1&show_popup_button=true&popup_width=1000&popup_height=500&saveimage=1&toolbarbg=F1F3F6&studies=[]&hideideas=1&theme=Light&style=1&timezone=Etc/UTC&studies_overrides={}&overrides={}&enabled_features=[]&disabled_features=[]&locale=en&utm_source=coinmarketcap.com&utm_medium=widget&utm_campaign=chart&utm_term=BTCUSDT`}
              ></iframe>
            </div>
          )}
        </div>

        <h1>Statistics of {match.params.id}</h1>
        <div className="SingleCrypto__thirdgrid">
          <div
            className="SingleCrypto__MainTable__Container"
            style={{ margin: 0 }}
          >
            <table className="SingleCrypto__MainTable">
              <tr className="SingleCrypto__MainTable__header">
                <th>No</th>
                <th>Name</th>
                <th>
                  {crypto && crypto.name ? crypto.name : <></>} (
                  {crypto && crypto.id ? crypto.id : <></>})
                </th>
              </tr>
              <tr>
                <td>1</td>
                <td>Price</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>
                    {crypto.price ? (
                      <NumberFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={
                          livePriceData
                            ? formatPrice(livePriceData[crypto.id])
                            : formatPrice(crypto.price / exchangeRate)
                        }
                        prefix={currencySymbol}
                      />
                    ) : (
                      "NA"
                    )}
                  </td>
                )}
              </tr>
              <tr>
                <td>2</td>
                <td>Price Change-24h</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>
                    {crypto["1d"] && crypto["1d"].price_change_pct ? (
                      <NumberFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={(
                          Number(crypto["1d"].price_change_pct) * 100
                        ).toFixed(2)}
                      />
                    ) : (
                      "NA"
                    )}
                  </td>
                )}
              </tr>
              <tr>
                <td>3</td>
                <td>Volume - 24h</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>
                    {crypto["1d"] && crypto["1d"].volume ? (
                      <NumberFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={crypto["1d"].volume / exchangeRate}
                        prefix={currencySymbol}
                      />
                    ) : (
                      "NA"
                    )}
                  </td>
                )}
              </tr>
              <tr>
                <td>4</td>
                <td>Market Cap</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>
                    {crypto.market_cap ? (
                      <NumberFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={crypto.market_cap / exchangeRate}
                        prefix={`${currencySymbol} `}
                      />
                    ) : (
                      "NA"
                    )}
                  </td>
                )}
              </tr>
              <tr>
                <td>5</td>
                <td>Dominance</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>
                    {crypto.market_cap_dominance
                      ? (crypto.market_cap_dominance * 100).toFixed(2) + "%"
                      : "NA"}
                  </td>
                )}
              </tr>
              <tr>
                <td>6</td>
                <td>ROI</td>
                <td>NA</td>
              </tr>
              <tr>
                <td>7</td>
                <td>All time High</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>
                    {crypto.high ? (
                      <NumberFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={Number(crypto.high).toFixed(2)}
                        prefix={`${currencySymbol} `}
                      />
                    ) : (
                      "NA"
                    )}
                  </td>
                )}
              </tr>
              <tr>
                <td>8</td>
                <td>Circulating Supply</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>
                    {crypto.circulating_supply
                      ? crypto.circulating_supply
                      : "NA"}
                  </td>
                )}
              </tr>
              <tr>
                <td>9</td>
                <td>Total Max Supply</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>{crypto.max_supply ? crypto.max_supply : "NA"}</td>
                )}
              </tr>
              <tr>
                <td>10</td>
                <td>Debut Trade</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>
                    {crypto.first_trade
                      ? moment(crypto.first_trade).format("yyyy")
                      : "NA"}
                  </td>
                )}
              </tr>
              <tr>
                <td>11</td>
                <td>Number of Exchanges</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>{crypto.num_exchanges ? crypto.num_exchanges : "NA"}</td>
                )}
              </tr>
              <tr>
                <td>12</td>
                <td>Number of Pairs</td>
                {loading || !crypto || !livePriceData ? (
                  <td>
                    <div
                      className="skeleton text"
                      style={{ width: "250px", height: "20px" }}
                    />
                  </td>
                ) : (
                  <td>{crypto.num_pairs ? crypto.num_pairs : "NA"}</td>
                )}
              </tr>
            </table>
          </div>
          <div>
            <iframe
              style={{ width: "100%", height: "400px", border: 0 }}
              title="trading__view__1"
              src={`https://s.tradingview.com/embed-widget/technical-analysis/?locale=in#{"show_popup_button":true,"interval":"1m","width":425,"isTransparent":false,"height":450,"symbol":"${
                match.params.id === "USDT"
                  ? "USDTUSD"
                  : `BINANCE:${match.params.id}USDT`
              }","showIntervalTabs":true,"color-theme":"dark","utm_source":"in.tradingview.com","utm_medium":"widget_new","utm_campaign":"technical-analysis"}`}
            ></iframe>

            <p style={{display:"flex",alignItems:"flex-end"}}><FcInfo size={20}/><span>All the above data is coming from <a               className="Footer__link" style={{color:"#8d0792",fontSize:"16px"}}
              href="https://tradingview.com"
              rel="noopener noreferrer"
              target="_blank">tradingview</a></span></p>
            {sentimentData &&
              sentimentData !== "undefined" &&
              sentimentAnalysis &&
              typeof sentimentAnalysis !== "undefined" && (
                <section className="sentimentContainer">
                  <section className="left">
                    <p>Negative</p>
                    <div class="meter">
                      <span
                        style={{
                          width: `${
                            (sentimentAnalysis.negative / total) * 100
                          }%`,
                        }}
                      >
                        <span
                          class="progressbar"
                          style={{
                            background:
                              "linear-gradient(90deg, #D81441 0%, #FF4B55 100.02%)",
                          }}
                        ></span>
                      </span>
                    </div>
                    <p>{sentimentAnalysis.negative}</p>
                    <p>Neutral</p>
                    <div class="meter">
                      <span
                        style={{
                          width: `${
                            (sentimentAnalysis.positive / total) * 100
                          }%`,
                        }}
                      >
                        <span
                          class="progressbar"
                          style={{
                            background:
                              "linear-gradient(90deg, #FE8C01 0%, #FFB528 99.74%)",
                          }}
                        ></span>
                      </span>
                    </div>
                    <p>{sentimentAnalysis.positive}</p> <p>Positive</p>
                    <div class="meter">
                      <span
                        style={{
                          width: `${
                            (sentimentAnalysis.neutral / total) * 100
                          }%`,
                        }}
                      >
                        <span
                          class="progressbar"
                          style={{
                            background:
                              "linear-gradient(90deg, #45AA43 0%, #4DE14A 100.09%, rgba(69, 170, 67, 0) 100.1%)",
                          }}
                        ></span>
                      </span>
                    </div>
                    <p>{sentimentAnalysis.neutral}</p>
                  </section>
                  <section className="right">
                    <h1>{sentimentAnalysis.sentimentScore}</h1>
                    <p>Sentiment Score</p>
                  </section>
                </section>
              )}
          </div>
          <div></div>
        </div>
        {/* 
      <div className="SingleCrypto__moreinfo" id="moreinfo">
        <h1>More Info</h1>
        <Accordion />
      </div> */}
        <div className="SingleCrypto__latestnews" id="news">
          <h1>Latest News</h1>
          <NewsContainer />
          <center>
            <button
              className="SingleCrypto__grid__compare__button"
              style={{ borderRadius: "5px", margin: "20px 0" }}
            >
              <Link to="/news" style={{ color: "white" }}>
                Read More
              </Link>
            </button>
          </center>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default SingleCrypto;
